import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  
  media: {
    width: "50%",
    height: "50%",
    marginLeft: '15px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '15px',
    height: '100%',
    position: 'relative',
  },
  mediar: {
    width: "auto",
    height: "auto",
    marginLeft: '5px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },

  map: {
    height: '100%',
    width: '90%',
    marginLeft: '15px',
    borderRadius: 15,
    margin: '20px 20px',
    paddingTop: '56.25%',
  },
  border: {
    border: 'solid',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '15px',
    height: '100%',
    position: 'relative',
  },
  highlight: {
    fontFamily: 'Poppins',
    fontSize: 18,
    position: 'absolute',
    fontStyle: 'bold',
    fontWeight: 'fontWeightBold',
    color: 'rgba(107, 54, 247, 1)',
  },
  normal: {
    fontFamily: 'Poppins',
    fontSize: 18,
    color: 'rgba(51, 51, 51, 1)',

    
  },
  normal1: {
    fontFamily: 'Poppins',
    fontSize: 16,
    color: 'rgba(51, 51, 51, 1)',
  },
  normal5: {
    fontFamily: 'Poppins',
    fontSize: 9,
    color: 'rgba(236, 88, 99, 1)',
  },
  grid: {
    display: 'flex',
  },
});